import BaseUseCase from "../../base_use_case.js.jsx";

class InvestmentQuestionnaireUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/projects/investment_steps/questionnaire`,
      data: this.wrapParams(params, "investment"),
    });
  }
}

const instance = new InvestmentQuestionnaireUseCase();
export default instance;